// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1F5Tn","validationTips":"StatementDescriptor_validationTips__1nbwS"};